import { Roles } from "@src/domains/shared/models/Enums/Roles";
import { AuthState, useAuth } from "@src/domains/shared/stores/authStore";
import { lazy } from "react";
import { Route, Routes } from "react-router-dom";

const MainMenu = lazy(
  () => import("@src/domains/Inventory/pages/Mobile/MainMenu"),
);
const Auditor = lazy(
  () => import("@src/domains/Inventory/pages/Mobile/Auditor"),
);
const Recorder = lazy(
  () => import("@src/domains/Inventory/pages/Mobile/Recorder"),
);
const MyList = lazy(
  () => import("@src/domains/Inventory/pages/Mobile/MyList"),
);

// Lazy imports
const ServiceOrderList = lazy(
  () =>
    import("@src/domains/Service/components/ServiceOrderList"),
);
const TechnicianCheckIn = lazy(
  () => import("@src/domains/Process/pages/Mobile/TechnicianCheckIn"),
);
const TechnicianFins = lazy(
  () =>
    import("@src/domains/Process/pages/Mobile/TechnicianFinsGeolocation"),
);
const TechnicianFinsPhoto = lazy(
  () => import("@src/domains/Process/pages/Mobile/TechnicianFinsPhoto"),
);
const TechnicianGeoLocation = lazy(
  () => import("@src/domains/Process/pages/Mobile/TechnicianGeoLocation"),
);
const TechnicianMenu = lazy(
  () => import("@src/domains/Process/pages/Mobile/TechnicianMenu"),
);
const TechnicianPhoto = lazy(
  () => import("@src/domains/Process/pages/Mobile/TechnicianPhoto"),
);

// Route definitions
const routeGroups = [
  {
    roles: [Roles.Service, Roles.ServiceCustomer],
    routes: [{ path: "services", element: <ServiceOrderList /> }],
  },
  {
    roles: [Roles.ProcessTechnician],
    routes: [
      { path: "technician", element: <TechnicianMenu /> },
      { path: "technician/fins/geolocation", element: <TechnicianFins /> },
      { path: "technician/photos-pending", element: <TechnicianFinsPhoto /> },
      {
        path: "technician/fins/:processId/geolocation",
        element: <TechnicianGeoLocation />,
      },
      { path: "technician/process-overview", element: <TechnicianCheckIn /> },
      { path: "technician/:processId/photos", element: <TechnicianPhoto /> },
    ],
  },
  {
    roles: [Roles.InventoryAuditor],
    routes: [{ path: "inventory/auditor", element: <Auditor /> }],
  },
  {
    roles: [Roles.InventoryRecorder],
    routes: [{ path: "inventory/recorder", element: <Recorder /> }],
  },
  {
    roles: [Roles.InventoryAuditor, Roles.InventoryRecorder],
    routes: [
      { path: "inventory", element: <MainMenu /> },
      { path: "inventory/my-list", element: <MyList /> },
    ],
  },
];

const MobileRoutes = () => {
  const { userRoles } = useAuth((state: AuthState) => state);

  return (
    <Routes>
      {routeGroups.map(({ roles, routes }) => {
        const hasAccess = roles.some((role) => userRoles.includes(role));

        return (
          hasAccess &&
          routes.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))
        );
      })}
    </Routes>
  );
};

export default MobileRoutes;
